var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOptions(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "iconos",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fill-parent",
    d: "M10.66,5.16A5.16,5.16,0,1,1,5.49,0,5.17,5.17,0,0,1,10.66,5.16Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "fill-parent",
    d: "M10.66,24a5.16,5.16,0,1,1-5.17-5.16A5.17,5.17,0,0,1,10.66,24Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "fill-parent",
    d: "M10.66,42.84a5.16,5.16,0,1,1-5.17-5.16A5.17,5.17,0,0,1,10.66,42.84Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptions);
export default __webpack_public_path__ + "static/media/options.a315ad25ded1835a12f5f0cfc23642ba.svg";
export { ForwardRef as ReactComponent };